export default __webpack_public_path__ + "static/media/blank-pfp.7179f4c0.webp";